  <app-template [name]="template" [data]="props"></app-template>
